<template>
  <div>
    <div class="top-card">
      <div class="card-item">
        <div class="user-info">
          <div class="user-name">
            <div class="text">{{ summaryData.name }}</div>
            <div class="icon"></div>
          </div>
          <div class="line"></div>
          <div class="school-info" v-if="schoolInfo&&schoolInfo.school_name&&summaryData&&summaryData.class_name">
            <div class="left flex1">
              <div class="title">
                <div class="icon"></div>
                <div class="text">院校</div>
              </div>
              <el-tooltip :content="schoolInfo.school_name" placement="bottom">
                <div class="name">{{ schoolInfo.school_name }}</div>
              </el-tooltip>

            </div>
            <div class="right flex1">
              <div class="title">
                <div class="icon"></div>
                <div class="text">班级</div>
              </div>
              <el-tooltip :content="summaryData.class_name.join('，')" placement="bottom">
                <div class="name">
                  <div class="name-item" v-for="item,index in summaryData.class_name" :key="index">
                    {{ item }}</div>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
      <div class="card-item" v-if="summaryData.visit_time">
        <div class="user-data">
          <div class="learn-time">
            <div class="title">累计学习时长</div>
            <div class="num">
              <div class="blod">{{ summaryData.visit_time }}</div>
            </div>
          </div>
          <div class="learn-num">
            <div class="title">累计学习课程数</div>
            <div class="num">
              <div class="blod">{{ summaryData.leran_course_num }}</div>
              <span>门</span>
            </div>
          </div>
          <div class="finish-num">
            <div class="title">累计完成课程数</div>
            <div class="num">
              <div class="blod">{{ summaryData.leran_course_finish_num }}</div>
              <span>门</span>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="echarts">
      <div class="echarts-item pie">
        <div class="title">各维度课程学习时长统计</div>
        <template v-if="show1">
          <div class="bgc"></div>
          <div class="chart-body" id="pie"></div>
          <div class="allTime">
            <p>{{ formatTime(learnAllTime) }}</p>
            <div class="label">累计学习时长</div>
          </div>
        </template>
        <div class="empty" v-else>
          <img src="../../../assets/data/empty.png">
          <p>暂无数据~</p>
        </div>

      </div>
      <div class="echarts-item bar">
        <div class="title">各维度学习课程数统计</div>
        <template>
          <div class="chart-body" id="bar" v-if="show2"> </div>
          <div class="empty" v-else>
            <img src="../../../assets/data/empty.png">
            <p>暂无数据~</p>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { graphic } from "echarts"
import services from "../../../config/services"
import { mapState } from "vuex"
export default {
  data () {
    return {
      summaryData: {},
      learnTime: [],
      learnAllTime: "",
      learnCourse: [],
      show1: false,
      show2: false,
    }
  },

  async mounted () {
    await this.initData()
    await this.initEcharts()
  },
  methods: {
    async initData () {
      let that = this
      await services.getStudySummary().then((res) => {
        that.summaryData = res.data
      })
      await services.getStudyTime().then((res) => {
        if (res && res.data && res.data.items) {
          that.learnAllTime = res.data.visit_time
          res.data.items.map((item, index) => {
            that.learnTime[index] = { name: item.category_name, value: item.visit_time * 1 }
          })
          that.show1 = true
        }

        // that.learnTime.push({ name: "党性修养", value: 15 }, { name: "职业素养", value: 20 }, { name: "家国情怀", value: 20 }, { name: "特色文化", value: 20 })
      })
      await services.getStudyCourse().then((res) => {
        if (res && res.data && res.data.items) {
          res.data.items.map((item, index) => {
            that.learnCourse[index] = { name: item.category_name, value: item.leran_course_count * 1 }
          })
          that.show2 = true
        }
      })
    },
    initEcharts () {
      let that = this
      // echarts学习时长统计配置项
      let learnTimeOptions = {
        tooltip: {
          show: true,
          trigger: 'item',
          backgroundColor: '#FFF',
          borderColor: '#EBEBF2',
          axisPointer: {
            type: 'shadow',
          },
          // tooltip边框阴影样式
          shadowStyle: {
            shadowColor: "rgba(103,103,103,0.4)",
            shadowOffsetX: 4,
            shadowOffsetY: 6,
          },
          formatter: function (val) { // 格式化tooltip
            return `
             <div style='width:6px;height:6px;background-color:${val.color};margin-right:6px;transform: translateY(13px);'></div>
            <div style='display:inline-block;padding:0 0 6px 10px;'>${val.name}占&nbsp;&nbsp;&nbsp;${val.percent}%</div><div>累计学习&nbsp;&nbsp;&nbsp;${that.formatTime(val.data.value)}</div>
            `
          },
          textStyle: {
            color: "#5E6369",
            fontSize: 13,
          },
          width: 164,
          height: 66,
        },
        legend: {
          left: 'center',
          bottom: 20,
          width: '100%',
          itemWidth: 6,
          itemHeight: 6,
          itemGap: 12,
          backgroundColor: "#fffbf7",
          padding: [15, 12,],
          formatter: [
            '{a|{name}}'
          ].join('\n'),
          textStyle: {
            rich: {
              a: {
                width: 80,
                fontSize: 12,
                lineHeight: 12,
                overflow: 'truncate',
                ellipsis: "...",
              }
            },
          },
          pageIconInactiveColor: "#cdcfd4",
          pageIconColor: "#2e87fc",
          pageTextStyle: {
            color: "#333333",
            fontSize: 14
          }
        },
        series: [
          {
            type: 'pie',
            radius: ['50%', '60%'],
            center: ["50%", "36%"],
            width: "100%",
            height: "100%",
            label: {
              show: false,
            },
            graphic: {
              elements: {
                type: "text",
                x: "50%",
                y: "50%",
              }
            },
            labelLine: {
              show: false
            },
            data: that.learnTime,
            emphasis: {
              scale: true,
              scaleSize: 8,
            },
          },
          // 内圈透明
          {
            type: 'pie',
            radius: ['35%', '50%'],
            center: ["50%", "36%"],
            avoidLabelOverlap: false,
            tooltip: {
              show: false,
            },
            label: {
              show: false,
            },
            zIndex: -1,
            labelLine: {
              show: false
            },
            data: that.learnTime,
            itemStyle: {
              normal: {
                borderWidth: 2, // 间距的宽度
                borderColor: '#fff', //背景色,
                opacity: .2,
              }
            },
            emphasis: false
          }

        ]
      };

      // echarts 学习课程数统计
      let learnCourseOptions = {
        tooltip: {
          show: true,
          trigger: 'item',
          backgroundColor: '#FFF',
          borderColor: '#EBEBF2',
          axisPointer: {
            type: 'shadow',
          },
          // tooltip边框阴影样式
          shadowStyle: {
            shadowColor: "rgba(103,103,103,0.4)",
            shadowOffsetX: 4,
            shadowOffsetY: 6,
          },
          formatter: function (val) { // 格式化tooltip
            return `
          <div style='font-size: 13px;color:5E6369;'>
           <p>${val.name}</p>
          <div style='display:flex;align-items:center;padding-top:6px;'>
             <div style='width:6px;height:6px;background-color:${val.color};margin-right:8px;'></div>
             <div style='display:inline-block;'>学习课程数：${val.value}</div>
          </div>
          </div>
            `
          },
          textStyle: {
            color: "#5E6369",
            fontSize: 13,
          },
          width: 164,
          height: 66,
        },
        xAxis: {
          data: that.handleBarData(that.learnCourse, "name"),
          type: 'category',
          axisLabel: {
            color: "#A4ADB7",
            fontSize: 14,
            margin: 14,
            interval: 0,
            clickable: true,
            // formatter: function (params, index) {
            //   if (index % 2 != 0) {
            //     return '\n\n' + params;
            //   } else {
            //     return params;
            //   }
            // },
            // nameLocation: 'end',
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: true
          },

        },
        yAxis: {
          type: 'value',
          minInterval: 1,
          axisTick: {
            show: true,
            lineStyle: {
              color: "#A4ADB7",
            },
            interval: 10
          },
          axisLabel: {
            color: "#A4ADB7",
            fontSize: 14,
            margin: 12
          },
        },
        grid: {
          top: 15,
          left: 30,
          right: 1,
          bottom: 58,
          // bottom: 30,
          show: true,
          backgroundColor: new graphic.LinearGradient(0, 1, 0, 0, [
            {
              offset: 0,
              color: '#EDF5FF',
            },
            {
              offset: 0.6,
              color: '#FFFFFF',
            },
            {
              offset: 1,
              color: '#FFFFFF',
            },
          ]),
          borderColor: "#E8F1FC"
        },
        series: [
          {
            data: that.handleBarData(that.learnCourse, "value"),
            type: 'bar',
            barWidth: 20,
            color: "#1E84FF",
          },
        ],
        color: ["#FFBE59", "#1E84FF", "#60D7A7", "#BED0E6", "#BED0E6"],

      };

      // 图例大于六个，展示一行数据，用分页切换
      if (this.learnTime.length > 6) {
        learnTimeOptions.legend.type = 'scroll'
      }
      if (that.show1) {
        var myChart = this.$echarts.init(document.getElementById('pie'), null, { renderer: 'svg' })
        myChart.setOption(learnTimeOptions)
      }
      if (that.show2) {
        var myChart1 = this.$echarts.init(document.getElementById('bar'), null, { renderer: 'svg' })
        myChart1.setOption(learnCourseOptions)
      }

    },

    handleBarData (arr, key) {
      let newArr = []
      if (arr && arr.length > 0) {
        arr.filter(item => {
          newArr.push(item[key])
        })
        return newArr
      }
    },
    formatTime (seconds) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const remainingSeconds = seconds % 60;
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
    }


  },
  computed: {
    ...mapState({
      loginUserInfo: (state) => state.appsLogin.appsUserInfo,
      schoolInfo: (state) => state.appsLogin.schoolInfo,
    })
  },
}
</script>

<style lang="less" scoped>
.top-card {
  display: flex;
  height: 140px;
  .card-item {
    border-top: 5px solid #90b1ff;
    border-radius: 5px;
    background: #fff;
    padding: 13px 20px 26px;
    flex: 0.62;
    &:not(:last-child) {
      margin-right: 6px;
      flex: 0.38;
    }
    .user-info {
      .user-name {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .text {
          font-size: 16px;
          font-weight: bold;
          color: #333333;
        }
        .icon {
          width: 20px;
          height: 20px;
          background-size: cover;
          background-image: url('../../../assets/data/name.png');
        }
      }
      .line {
        width: 100%;
        height: 1px;
        background: #f3f4f5;
        margin: 12px 0 14px;
      }
      .school-info {
        display: flex;
        .flex1 {
          flex: 1;
          .title {
            display: flex;
            align-items: center;
            padding-bottom: 3px;
            .text {
              font-size: 14px;
              color: #7a828b;
            }
          }
          .name {
            display: inline-block;
            font-size: 14px;
            color: #5e6369;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            cursor: default;
          }
          &.left {
            .icon {
              width: 12px;
              height: 15px;
              background-size: cover;
              background-image: url('../../../assets/data/school.png');
              margin-right: 7px;
            }
          }
          &.right {
            .icon {
              width: 12px;
              height: 14px;
              background-size: cover;
              background-image: url('../../../assets/data/major.png');
              margin-right: 7px;
            }
          }
          &.left {
            .name {
              padding-right: 10px;
            }
          }
        }
      }
    }
    .user-data {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 100%;
      padding: 0 28px 0 18px;
      .title {
        font-size: 12px;
        color: #5e6369;
        line-height: 1;
        margin-bottom: 18px;
      }
      &.user-data {
        & > div {
          position: relative;
          width: 30%;
          &:not(:last-child)::after {
            content: '';
            display: inline-block;
            position: absolute;
            width: 1px;
            height: 66px;
            background: #f3f4f5;
            top: 50%;
            right: 3px;
            transform: translate(0, -50%);
          }
        }
        .learn-time {
          .num {
            width: 103px;
            height: 42px;
            background-image: url('../../../assets/data/study-time.png');
            padding-top: 3px;
            background-size: cover;
          }
          .blod {
            font-size: 16px;
            font-weight: bold;
            color: #43474a;
            transform: translateX(40px);
          }
        }
        .learn-num {
          .num {
            width: 103px;
            height: 42px;
            background-image: url('../../../assets/data/study-course.png');
            padding-top: 3px;
            background-size: cover;
            display: flex;
          }
          .blod {
            font-size: 16px;
            font-weight: bold;
            color: #43474a;
            transform: translateX(40px);
          }
          span {
            font-size: 12px;
            color: #5e6369;
            display: block;
            transform: translate(48px, 3px);
          }
        }
        .finish-num {
          .num {
            width: 103px;
            height: 42px;
            background-image: url('../../../assets/data/finish.png');
            padding-top: 3px;
            background-size: cover;
            display: flex;
          }
          .blod {
            font-size: 16px;
            font-weight: bold;
            color: #43474a;
            transform: translateX(40px);
          }
          span {
            font-size: 12px;
            color: #5e6369;
            display: block;
            transform: translate(48px, 3px);
          }
        }
      }
    }
  }
}
.echarts {
  width: 100%;
  height: 619px;
  background: #ffffff;
  display: flex;
  margin-top: 24px;
  .echarts-item {
    position: relative;
    .title {
      font-size: 16px;
      font-weight: bold;
      color: #333333;
    }
    .bgc {
      width: 85%;
      height: 245px;
      background: #fafbff;
      position: absolute;
      top: 70px;
      left: 50%;
      transform: translate(-50%, 0);
    }
    &.pie {
      flex: 0.38;
      padding: 29px 30px;
      .allTime {
        position: absolute;
        top: 31%;
        left: 50%;
        transform: translate(-50%, -50%);
        p {
          font-size: 18px;
          color: #21242b;
          line-height: 1;
          padding-bottom: 5px;
        }
        .label {
          font-size: 13px;
          color: #a4adb7;
          line-height: 1;
        }
      }
    }
    &.bar {
      flex: 0.62;
      padding: 29px 26px 0 13px;
    }
    .chart-body {
      width: 100%;
      height: 330px;
      margin-top: 20px;
    }
  }
}

.empty {
  text-align: center;
  position: absolute;
  left: 50%;
  top: 35%;
  transform: translate(-50%, -50%);
  img {
    width: 228px;
    height: auto;
  }
  p {
    padding-top: 20px;
    font-size: 14px;
    color: #999999;
  }
}
</style>